import * as React from "react";
import type { SVGProps } from "react";
const SvgFavorite = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.771 3.77a5.71 5.71 0 0 1 6.361.33l.868.65.868-.65A5.708 5.708 0 0 1 22 8.664v.463c0 2.086-.71 4.11-2.013 5.74a20.7 20.7 0 0 1-5.5 4.806l-1.973 1.183-.514.309-.514-.309-1.25-.75a1 1 0 0 1 1.028-1.715l.736.442 1.457-.875a18.7 18.7 0 0 0 4.968-4.341A7.2 7.2 0 0 0 20 9.128v-.463A3.708 3.708 0 0 0 14.068 5.7L12.6 6.8l-.6.45-.6-.45-1.468-1.1A3.71 3.71 0 0 0 5.8 5.486l-.055.033A3.6 3.6 0 0 0 4 8.601c0 1.954.7 3.845 1.971 5.329l.763.89 1.473 1.473a1 1 0 1 1-1.414 1.414l-1.5-1.5-.027-.027-.025-.03-.788-.919A10.2 10.2 0 0 1 2 8.601a5.6 5.6 0 0 1 2.716-4.797z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgFavorite;
